const fileStatusType = {
  FILE_UPLOAD_SUCCESS: "FILE_UPLOAD_SUCCESS",
  FILE_UPLOAD_LOADING: "FILE_UPLOAD_LOADING",
  FILE_UPLOAD_ON_SERVER_LOADING: "FILE_UPLOAD_ON_SERVER_LOADING",
  FILE_UPLOAD_FAIL: "FILE_UPLOAD_FAIL",
  FILE_EMPTY: "FILE_EMPTY",
  GET_ACTIVE_INDEX: "GET_ACTIVE_INDEX",
};
export default fileStatusType;